import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addStockEntry = catchAsync(async (body) => {
  const { data } = await axiosInstance.post('/api/resource/Stock Entry', body);
  return data;
});
export const updateStockEntry = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Stock Entry/${id}`,
    body
  );
  return data;
});

export const getStockEntry = catchAsync(async ({ key = '', value = '' }) => {
  let baseUrl =
    '/api/resource/Stock Entry?fields=["name","stock_entry_type","posting_date","total_outgoing_value","total_incoming_value","docstatus"]&limit_page_length=0';
  if (value) {
    baseUrl += `&filters=[["${key}","like","%${value}%"]]`;
  }
  const { data } = await axiosInstance.get(baseUrl);
  return data;
});
export const deleteStockEntry = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Stock Entry/${record}`
  );
  return data;
});
export const getStockEntryDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(`/api/resource/Stock Entry/${id}`);
  return data;
});
export const getMaterialDetailsInStock = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.map_reference?target=MR SE&source=${id}`
  );
  return data;
});
